import { ListItem, AHIcon, useTheme } from "arkh";
import { FormattedMessage } from "react-intl";
import { Switch } from "react-native";
import { graphql, useFragment, useMutation } from "react-relay";
import { WorkspaceTodoEditMainPushNotification_todoWorkspace$key } from "./__generated__/WorkspaceTodoEditMainPushNotification_todoWorkspace.graphql";
import { WorkspaceTodoEditMainPushNotificationMutation } from "./__generated__/WorkspaceTodoEditMainPushNotificationMutation.graphql";

export function WorkspaceTodoEditMainPushNotification(props: {
  todoWorkspace: WorkspaceTodoEditMainPushNotification_todoWorkspace$key;
  disabled?: boolean;
}) {
  const workspaceTodo = useFragment(
    graphql`
      fragment WorkspaceTodoEditMainPushNotification_todoWorkspace on TodoWorkspace {
        id
        sendNotificationAtPublish

        updatedAtDate {
          ...FormattedDate
          isoString
        }
        updatedBy {
          name
          id
        }
      }
    `,
    props.todoWorkspace
  );
  const theme = useTheme();

  const colorProps = {
    activeThumbColor: theme.primary,
    activeTrackColor: theme["track-background"],
    trackColor: theme["border-strong"],
  } as any;

  const [mutate] = useMutation<WorkspaceTodoEditMainPushNotificationMutation>(
    graphql`
      mutation WorkspaceTodoEditMainPushNotificationMutation(
        $id: ID!
        $sendNotificationAtPublish: Boolean!
      ) @raw_response_type {
        todoWorkspace(id: $id) {
          updateNotification(
            sendNotificationAtPublish: $sendNotificationAtPublish
          ) {
            sendNotificationAtPublish
            updatedAtDate {
              ...FormattedDate
            }
            updatedBy {
              name
              id
            }
          }
        }
      }
    `
  );

  const setValue = (val: boolean) => {
    mutate({
      variables: {
        id: workspaceTodo.id,
        sendNotificationAtPublish: val,
      },
      optimisticResponse: {
        todoWorkspace: {
          updateNotification: {
            id: workspaceTodo.id,
            sendNotificationAtPublish: val,
            updatedAtDate: workspaceTodo.updatedAtDate
              ? {
                  ...workspaceTodo.updatedAtDate,
                  __isDate: "UnzonedDate" as const,
                }
              : null,

            updatedBy: workspaceTodo.updatedBy,
          },
        },
      },
    });
  };

  return (
    <ListItem
      border="border-primary"
      color={props.disabled ? "transparent" : "surface-primary"}
      right={
        <Switch
          {...colorProps}
          style={{
            opacity: props.disabled ? 0.4 : 1,
          }}
          disabled={props.disabled}
          value={workspaceTodo.sendNotificationAtPublish}
          onValueChange={setValue}
        />
      }
      isFirst
      isLast
      disabled
      left={<AHIcon type="notification" color="darkText" />}
    >
      <ListItem.TitleSecondary>
        <FormattedMessage
          defaultMessage="Send push notification"
          description="Workspace todo edit recipients label"
        />
      </ListItem.TitleSecondary>
    </ListItem>
  );
}
